import { Link } from 'react-router-dom';

const editorAvatars = [
  'https://readdy.ai/api/search-image?query=Minimalist%20professional%20portrait%20of%20fashion%20curator%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20sepia%20tones%2C%20clean%20composition%2C%20simple%20and%20elegant%20aesthetic&width=120&height=120&seq=avatar-editor-01&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20a%20female%20fashion%20stylist%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20earth%20tones%2C%20clean%20composition%2C%20simple%20and%20refined%20aesthetic&width=120&height=120&seq=avatar-editor-02&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Simple%20portrait%20of%20a%20young%20fashion%20trend%20analyst%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20minimal%20and%20elegant%20aesthetic&width=120&height=120&seq=avatar-editor-03&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Refined%20portrait%20of%20a%20fashion%20editor%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20sand%20tones%2C%20clean%20composition%2C%20simple%20and%20sophisticated%20aesthetic&width=120&height=120&seq=avatar-editor-04&orientation=squarish',
];

export default function ArticlePreview() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <p className="text-xs font-medium tracking-widest uppercase text-foreground-400 mb-6">
              /pandabuy sheet guide
            </p>

            <div className="flex items-center gap-4 mt-12">
              <div className="flex -space-x-3">
                {editorAvatars.map((url, i) => (
                  <img
                    key={i}
                    src={url}
                    alt="Fashion editor"
                    className="w-10 h-10 rounded-full border-2 border-white object-cover"
                  />
                ))}
              </div>
              <span className="text-sm text-foreground-500 font-medium">Curated by Fashion Editors</span>
            </div>
          </div>

          <div className="lg:w-3/5">
            <article className="max-w-2xl">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                Welcome to <strong>pandabuyspreadsheet</strong>, the most complete and updated curated spreadsheet for finding high-quality fashion items at budget prices. This platform is designed for users searching for pandabuy spreadsheet finds, cheap streetwear lists, budget sneaker collections, viral TikTok fashion items, and China shopping agent spreadsheets.
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                We organize thousands of items into structured spreadsheet-style lists, making it easy to discover, compare, and evaluate products quickly. Unlike random lists, our <strong>pandabuyspreadsheet system</strong> is structured using category-based filtering, price segmentation, quality rating system, and weekly updates based on trending products.
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8">
                If you are looking for the most efficient way to find fashion deals online, this is your starting point. Our curated spreadsheet combines the best of community-driven discovery with professional editorial curation, giving you access to items that have been verified, rated, and organized for maximum shopping efficiency.
              </p>

              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/article/pandabuy-spreadsheet-guide"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-white rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
                >
                  Read SEO Guide
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/shopping-guide"
                  className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 rounded-full text-sm font-semibold text-foreground-700 hover:border-foreground-700 transition-all cursor-pointer whitespace-nowrap"
                >
                  View All Guides
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}